import { getNodeResolvers } from "./getNodeResolvers";
import { getMarkResolvers } from "./getMarkResolvers";
import { DefaultBlokResolver } from "./getDefaultBlokResolver";

export { getNodeResolvers, getMarkResolvers, DefaultBlokResolver };
